// Password prompt modal — styled to match the game UI

import { FONT, PANEL_BG, BORDER, TEXT, TEXT_DIM, ACCENT, INPUT_BG } from "./theme.js";

export function showPasswordPrompt(serverName: string): Promise<string | null> {
  return new Promise((resolve) => {
    const overlay = document.createElement("div");
    overlay.style.cssText =
      `position:fixed;inset:0;display:flex;align-items:center;justify-content:center;` +
      `z-index:2000;background:rgba(0,0,0,0.6);backdrop-filter:blur(4px);`;

    const panel = document.createElement("div");
    panel.style.cssText =
      `width:320px;background:${PANEL_BG};border:1px solid ${BORDER};padding:20px;`;

    const title = document.createElement("div");
    title.textContent = "PASSWORD REQUIRED";
    title.style.cssText = `font:bold 13px ${FONT};color:${TEXT};letter-spacing:2px;margin-bottom:6px;`;
    panel.appendChild(title);

    const sub = document.createElement("div");
    sub.textContent = serverName;
    sub.style.cssText = `font:11px ${FONT};color:${TEXT_DIM};margin-bottom:14px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;`;
    panel.appendChild(sub);

    const input = document.createElement("input");
    input.type = "password";
    input.placeholder = "Enter password";
    input.style.cssText =
      `width:100%;box-sizing:border-box;padding:8px;background:${INPUT_BG};` +
      `color:${TEXT};border:1px solid ${BORDER};font:12px ${FONT};outline:none;margin-bottom:14px;`;
    panel.appendChild(input);

    const btnRow = document.createElement("div");
    btnRow.style.cssText = "display:flex;gap:8px;";

    const joinBtn = document.createElement("button");
    joinBtn.textContent = "JOIN";
    joinBtn.style.cssText =
      `flex:1;padding:7px;background:${ACCENT};color:#fff;border:none;cursor:pointer;` +
      `font:bold 11px ${FONT};letter-spacing:1px;`;

    const cancelBtn = document.createElement("button");
    cancelBtn.textContent = "CANCEL";
    cancelBtn.style.cssText =
      `padding:7px 14px;background:transparent;color:${TEXT_DIM};border:1px solid ${BORDER};` +
      `cursor:pointer;font:11px ${FONT};`;

    btnRow.append(joinBtn, cancelBtn);
    panel.appendChild(btnRow);
    overlay.appendChild(panel);
    document.body.appendChild(overlay);

    input.focus();

    // Click outside modal to cancel
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) cleanup(null);
    });

    function cleanup(result: string | null): void {
      overlay.remove();
      resolve(result);
    }

    joinBtn.addEventListener("click", () => {
      const pw = input.value;
      if (pw) cleanup(pw);
    });

    cancelBtn.addEventListener("click", () => cleanup(null));

    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && input.value) cleanup(input.value);
      if (e.key === "Escape") cleanup(null);
    });
  });
}
